export default {
      id: "track-complaint-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "sprite.svg#track-complaint",
      toString: function () {
        return this.url;
      }
    }